import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";
import { PurchasableStateMeta } from "./PurchasableStateMeta";

export const DamageWaiverMemberMetaFields = {
  waiverId: propertyMeta("waiverId", false, true, false, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.currency),
  purchaseDate: propertyMeta("purchaseDate", false, false, false, MetaTypesBase.Date),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.Date),
  expirationDate: propertyMeta("expirationDate", false, false, false, MetaTypesBase.Date),
  purchasableState: propertyMeta("purchasableState", false, true, false, PurchasableStateMeta),
  voidCloseId: propertyMeta("voidCloseId", false, false, false, MetaTypesBase.number),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
  optionName: propertyMeta("optionName", false, false, false, MetaTypesBase.string),
  optionDisplayName: propertyMeta("optionDisplayName", false, false, false, MetaTypesBase.string),
};

export const DamageWaiverMemberMeta = typeMeta("DamageWaiverMember", DamageWaiverMemberMetaFields);
